import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from "./module_roots/AuthContext";
import PrivateRoute from "./module_roots/PrivateRoute";

// Lazy load heavy components
const Login = lazy(() => import("./module_roots/Login"));
const DashboardSuperAdmin = lazy(() => import("./module_superadmin/Dashboard/Dashboard_SuperAdmin"));
const DashboardPOS = lazy(() => import("./module_salanty/Dashboard/Dashboard_POS"));
const DashboardPO = lazy(() => import("./module_salanty/Dashboard/Dashboard_PO"));
const DashboardFabrics = lazy(() => import("./module_fabrics/Dashboard/Dashboard_Fabrics"));
const DashboardMechanicsTH = lazy(() => import("./module_mechanics/Dashboard/Dashboard_MechanicsTH"));
const DashboardMechanicsAP = lazy(() => import("./module_mechanics/Dashboard/Dashboard_MechanicsAP"));
const DashboardHardwareAP = lazy(() => import("./module_hardware/Dashboard/Dashboard_HardwareAP"));
const DashboardHardwareTH = lazy(() => import("./module_hardware/Dashboard/Dashboard_HardwareTH"));
const DashboardAutosAP = lazy(() => import("./module_autos/Dashboard/Dashboard_AutosAP"));
const DashboardAutosTH = lazy(() => import("./module_autos/Dashboard/Dashboard_AutosTH"));
const DashboardPharmacy = lazy(() => import("./module_pharmacy/Dashboard/Dashboard_Pharmacy"));
const DashboardPharmacyTAX = lazy(() => import("./module_pharmacy/Dashboard/Dashboard_PharmacyTAX"));
const DashboardBusinessModule = lazy(() => import("./module_cosmetics/Dashboard/Dashboard_BusinessModule"));
const DashboardElectronics = lazy(() => import("./module_electronics/Dashboard/Dashboard_Electronics"));
const DashboardSolar = lazy(() => import("./module_solar/Dashboard/Dashboard_Solar"));
const LedgerView = lazy(() => import("./module_cosmetics/LedgerView"));
const SellList = lazy(() => import("./module_fabrics/Fab_SaleList"));
const DashboardLayout = lazy(() => import("./module_superadmin/Dashboard/DashboardLayout"));

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Login Route */}
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          
          {/* ── Ledger View (Public/Private - accessible with valid shop_id) ── */}
          <Route path="/ledger" element={<LedgerView />} />
          
          {/* Super Admin Dashboard - exact path without /* to avoid conflicts */}
          <Route
            path="/DashboardSuperAdmin"
            element={
              <PrivateRoute requiredRole="super_admin">
                <DashboardSuperAdmin />
              </PrivateRoute>
            }
          />

          <Route
            path="/DashboardSuperAdmin/*"
            element={
              <PrivateRoute requiredRole="super_admin">
                <DashboardSuperAdmin />
              </PrivateRoute>
            }
          />

          {/* POS Dashboard */}
          <Route
            path="/DashboardPOS"
            element={
              <PrivateRoute allowedRoles={['admin_pos', 'manager_pos', 'user_pos', 'viewer_pos']}>
                <DashboardPOS />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardPOS/*"
            element={
              <PrivateRoute allowedRoles={['admin_pos', 'manager_pos', 'user_pos', 'viewer_pos']}>
                <DashboardPOS />
              </PrivateRoute>
            }
          />

          {/* PO Dashboard */}
          <Route
            path="/DashboardPO"
            element={
              <PrivateRoute allowedRoles={['admin_po', 'manager_po', 'user_po', 'viewer_po']}>
                <DashboardPO />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardPO/*"
            element={
              <PrivateRoute allowedRoles={['admin_po', 'manager_po', 'user_po', 'viewer_po']}>
                <DashboardPO />
              </PrivateRoute>
            }
          />

          {/* Fabrics Dashboard */}
          <Route
            path="/DashboardFabrics"
            element={
              <PrivateRoute allowedRoles={['admin_fabrics', 'manager_fabrics', 'user_fabrics', 'viewer_fabrics']}>
                <DashboardFabrics />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardFabrics/*"
            element={
              <PrivateRoute allowedRoles={['admin_fabrics', 'manager_fabrics', 'user_fabrics', 'viewer_fabrics']}>
                <DashboardFabrics />
              </PrivateRoute>
            }
          />

          {/* Mechanics Dashboard THERMAL*/}
          <Route
            path="/DashboardMechanicsTh"
            element={
              <PrivateRoute allowedRoles={['admin_mechanicsth', 'manager_mechanicsth', 'user_mechanicsth', 'viewer_mechanicsth']}>
                <DashboardMechanicsTH />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardMechanicsTh/*"
            element={
              <PrivateRoute allowedRoles={['admin_mechanicsth', 'manager_mechanicsth', 'user_mechanicsth', 'viewer_mechanicsth']}>
                <DashboardMechanicsTH />
              </PrivateRoute>
            }
          />

            {/* Mechanics Dashboard LARGE PRINTER*/}
          <Route
            path="/DashboardMechanicsAp"
            element={
              <PrivateRoute allowedRoles={['admin_mechanicsap', 'manager_mechanicsap', 'user_mechanicsap', 'viewer_mechanicsap']}>
                <DashboardMechanicsAP />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardMechanicsAp/*"
            element={
              <PrivateRoute allowedRoles={['admin_mechanicsap', 'manager_mechanicsap', 'user_mechanicsap', 'viewer_mechanicsap']}>
                <DashboardMechanicsAP />
              </PrivateRoute>
            }
          />

          {/* Hardware Dashboard LARGE PRINTER*/}
          <Route
            path="/DashboardHardwareAp"
            element={
              <PrivateRoute allowedRoles={['admin_hardwareap', 'manager_hardwareap', 'user_hardwareap', 'viewer_hardwareap']}>
                <DashboardHardwareAP />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardHardwareAp/*"
            element={
              <PrivateRoute allowedRoles={['admin_hardwareap', 'manager_hardwareap', 'user_hardwareap', 'viewer_hardwareap']}>
                <DashboardHardwareAP />
              </PrivateRoute>
            }
          />

          {/* Hardware Dashboard THERMAL*/}
          <Route
            path="/DashboardHardwareTh"
            element={
              <PrivateRoute allowedRoles={['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'viewer_hardwareth']}>
                <DashboardHardwareTH />
              </PrivateRoute>
            }

          />
          <Route
            path="/DashboardHardwareTh/*"
            element={
              <PrivateRoute allowedRoles={['admin_hardwareth', 'manager_hardwareth', 'user_hardwareth', 'viewer_hardwareth']}>
                <DashboardHardwareTH />
              </PrivateRoute>
            }
          />



          {/* Autos Dashboard LARGE PRINTER*/}
          <Route
            path="/DashboardAutosAp"
            element={
              <PrivateRoute allowedRoles={['admin_autosap', 'manager_autosap', 'user_autosap', 'viewer_autosap']}>
                <DashboardAutosAP />
              </PrivateRoute>
            }
          />
          <Route
            path="/DashboardAutosAp/*"
            element={
              <PrivateRoute allowedRoles={['admin_autosap', 'manager_autosap', 'user_autosap', 'viewer_autosap']}>
                <DashboardAutosAP />
              </PrivateRoute>
            }
          />

          {/* Autos Dashboard THERMAL*/}
          <Route
            path="/DashboardAutosTh"
            element={
              <PrivateRoute allowedRoles={['admin_autosth', 'manager_autosth', 'user_autosth', 'viewer_autosth']}>
                <DashboardAutosTH />
              </PrivateRoute>
            }

          />
          <Route
            path="/DashboardAutosTh/*"
            element={
              <PrivateRoute allowedRoles={['admin_autosth', 'manager_autosth', 'user_autosth', 'viewer_autosth']}>
                <DashboardAutosTH />
              </PrivateRoute>
            }
          />



          {/* Pharmacy Dashboard*/}
          <Route
            path="/DashboardPharmacy"
            element={
              <PrivateRoute allowedRoles={['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'viewer_pharmacy']}>
                <DashboardPharmacy />
              </PrivateRoute>
            }

          />
          <Route
            path="/DashboardPharmacy/*"
            element={
              <PrivateRoute allowedRoles={['admin_pharmacy', 'manager_pharmacy', 'user_pharmacy', 'viewer_pharmacy']}>
                <DashboardPharmacy />
              </PrivateRoute>
            }
          />


          {/* Pharmacy Dashboard With TAX*/}
          <Route
            path="/DashboardTxPharmacy"
            element={
              <PrivateRoute allowedRoles={['admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax', 'viewer_pharmacytax']}>
                <DashboardPharmacyTAX />
              </PrivateRoute>
            }

          />
          <Route
            path="/DashboardTxPharmacy/*"
            element={
              <PrivateRoute allowedRoles={['admin_pharmacytax', 'manager_pharmacytax', 'user_pharmacytax', 'viewer_pharmacytax']}>
                <DashboardPharmacyTAX />
              </PrivateRoute>
            }
          />


          {/* -----COMMON BUSINESES GENERAL DASHBOARDS*/}
          <Route
            path="/BusinessDashboard"
            element={
              <PrivateRoute allowedRoles={['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics', 'viewer_cosmetics',]}>
                <DashboardBusinessModule />
              </PrivateRoute>
            }

          />
          <Route
            path="/BusinessDashboard/*"
            element={
              <PrivateRoute allowedRoles={['admin_cosmetics', 'manager_cosmetics', 'user_cosmetics', 'viewer_cosmetics']}>
                <DashboardBusinessModule />
              </PrivateRoute>
            } 
          />


          {/* ----- MODULE SOLAR DASHBOARDS*/}
          <Route
            path="/DashboardSolar"
            element={
              <PrivateRoute allowedRoles={['admin_solar', 'manager_solar', 'user_solar', 'viewer_solar']}>
                <DashboardSolar />
              </PrivateRoute>
            }

          />
          <Route
            path="/DashboardSolar/*"
            element={
              <PrivateRoute allowedRoles={['admin_solar', 'manager_solar', 'user_solar', 'viewer_solar']}>
                <DashboardSolar />
              </PrivateRoute>
            }
          />


          {/* ----- MODULE ELECTRONICS DASHBOARDS*/}
          <Route
            path="/DashboardElectronics/"
            element={
              <PrivateRoute allowedRoles={['admin_electronics', 'manager_electronics', 'user_electronics', 'viewer_electronics']}>
                <DashboardElectronics />
              </PrivateRoute>
            }

          />
          <Route
            path="/DashboardElectronics/*"
            element={
              <PrivateRoute allowedRoles={['admin_electronics', 'manager_electronics', 'user_electronics', 'viewer_electronics']}>
                <DashboardElectronics />
              </PrivateRoute>
            }
          />

          {/* Legacy Dashboard route - fallback */}
          <Route
            path="/Dashboard/*"
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          />

          {/* ----- FABRICS REDIRECTIONS --------------------------------------------------------------------- */}
          {/* Legacy Dashboard route - fallback */}
          <Route
            path="/dashboard/fab-sales"
            element={
              <PrivateRoute>
                <SellList />
              </PrivateRoute>
            }
          />

          {/* Catch all - redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;